export default __webpack_public_path__ + "static/media/svg-4.f9dbac74.svg";